const amountFormatter = (value) => value
  .replace(/[,]/g, '.')
  .replace(/[^0-9.]/g, '')
  .replace(/^0+/, '0')
  .replace(/^\./, '0.')
  .replace(/^0([^.])/, '$1');

export default amountFormatter;
